import Loadable from "@loadable/component";

const Cart = Loadable(
  () => import(/* webpackChunkName: "cart_page" */ "./cartPage")
);

export default Cart;
